import { fieldValidations } from "./fieldValidations";

export default {
  firstName: {
    value: "",
    label: "Legal First Name",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    isRequired: true,
    maxLength: "50"
  },
  middleName: {
    value: "",
    label: "Legal Middle Name",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    isRequired: true,
    maxLength: "50"
  },
  lastName: {
    value: "",
    label: "Legal Last Name",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    isRequired: true,
    maxLength: "50"
  },
  maidenName: {
    value: "",
    label: "Legal Maiden Name",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    maxLength: "50"
  },
  otherName: {
    value: "",
    label: "Other Name",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    maxLength: "50"
  },
  applicantPhone: {
    value: "",
    label: "Phone Number",
    validation: fieldValidations.isCompletePhone,
    maxLength: 12,
    errMessage: "",
    className: "",
    isRequired: true
  },
  VADOCEmployee: {
    value: "",
    legend:
      "Are you a current or former VADOC employee, contractor, or volunteer?",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    isRequired: true
  },
  activeParole: {
    value: "",
    legend: "Are you currently under active parole or probation supervision?",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    isRequired: true
  },
  VADOCId: {
    value: "",
    label: "VADOC Identification Number",
    validation: fieldValidations.isNumeric,
    errMessage: "",
    isRequired: false
  },
  ppDistrict: {
    value: "",
    label: "Probation & Parole District",
    validation: fieldValidations.hasForbiddenChars,
    errMessage: "",
    isRequired: false
  },
  felonyConviction: {
    value: "",
    legend: "Have you ever been convicted of a felony as a juvenile or adult?",
    tipTitle: "",
    info:
      "Select yes even if your civil rights have been restored by the Governor (you have regained the right to vote, own a firearm, serve on a jury, run for office, and become a notary public).",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    fatal: false,
    isRequired: true
  },
  protectiveOrder: {
    value: "",
    legend:
      "Are you banned from having contact with an inmate under an existing protective order, no-contact order, or Child Protective Services/Adult Protective Services ruling?",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    fatal: true,
    fatalVal: "yes",
    isRequired: true
  },
  gangAssociation: {
    value: "",
    legend:
      "Are you currently or have you previously been a member of a gang, racial supremacy group, or another similar organization as defined in the Code of Virginia §18.2-46.1?",
    tipTitle: "Code of Virginia §18.2-46.1",
    info:
      "“Criminal street gang” means any ongoing organizaton, associaton, or group of three or more persons, whether formal or informal, i) which has one of its primary objectives or activities the commission of one or more criminal activities; ii) which has an identifiable name or identifying sign or symbol; and iii) whose members individually or collectively have engaged in the commission of, attempt to commit, conspiracy to commit, or solicitation of two or more predictable criminal acts, at least one of which is an act of violence, provided such acts were not part of a common act or transaction.",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    fatal: true,
    fatalVal: "yes",
    isRequired: true
  },
  eligibleRehire: {
    value: "",
    legend:
      "Are you eligible for re-hiring? If a volunteer, are you allowed to return?",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    isRequired: true
  },
  meetOffender: {
    value: "",
    legend:
      "Did you meet any of the inmates while you were an employee, contractor, or volunteer at the VADOC?",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    isRequired: true
  },
  employmentStatus: {
    value: "",
    legend: "VADOC Employment Status ",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    options: [
      {
        label: "Current Employee/Volunteer",
        value: "Current Employee/Volunteer"
      },
      { label: "Former Employee/Volunteer", value: "Former Employee/Volunteer" }
    ],
    isRequired: true
  },
  employmentStartDate: {
    value: "",
    label: "Start Date",
    className: "",
    validation: fieldValidations.isValidDate,
    errMessage: "",
    isRequired: true
  },
  employmentEndDate: {
    value: "",
    label: "End Date",
    className: "",
    validation: fieldValidations.isValidDate,
    errMessage: "",
    isRequired: false
  },
  employmentTitle: {
    value: "",
    label: "Position/Title",
    validation: fieldValidations.hasForbiddenChars,
    errMessage: "",
    className: "",
    isRequired: true
  },
  employmentAlias: {
    value: "",
    label: "Name Used if Different from Current",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: ""
  },
  employmentLocation: {
    value: "",
    label: "Workplace Location",
    validation: fieldValidations.hasForbiddenChars,
    errMessage: "",
    className: "",
    isRequired: true
  },
  offenderSearchFirstName: {
    value: "",
    label: "First Name",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    isRequired: true
  },
  offenderSearchLastName: {
    value: "",
    label: "Last Name",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    isRequired: true
  },
  offenderSearchId: {
    value: "",
    label: "Inmate ID #",
    validation: fieldValidations.isNumeric,
    errMessage: "",
    className: "",
    isRequired: true
  },
  offenderSearchMiddleName: {
    value: "",
    label: "Middle Name",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: ""
  },
  offenderSearchAlias: {
    value: "",
    label: "Alias",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: ""
  },
  offenderSearchReleaseDate: {
    value: "",
    label: "Release Date",
    validation: fieldValidations.isValidDate,
    errMessage: "",
    className: ""
  },
  offenderSearchAgeFrom: {
    value: 18,
    label: "From",
    validation: fieldValidations.isNumeric,
    errMessage: "",
    className: ""
  },
  offenderSearchAgeTo: {
    value: 99,
    label: "To",
    validation: fieldValidations.isNumeric,
    errMessage: "",
    className: ""
  },
  offenderSearchRace: {
    value: "",
    label: "Race",
    validation: fieldValidations.isAlpha,
    errMessage: "",
    options: [
      { label: "American Indian or Alaskan Native", value: "15" },
      { label: "Asian or Pacific Islander", value: "16" },
      { label: "Black", value: "17" },
      { label: "Unknown", value: "19" },
      { label: "White", value: "18" }
    ],
    className: ""
  },
  offenderSearchSex: {
    value: "",
    label: "Sex",
    validation: fieldValidations.isAlpha,
    errMessage: "",
    options: [{ label: "Female", value: "13" }, { label: "Male", value: "12" }],
    className: ""
  },
  selectedOffenders: {},
  applicantDOB: {
    value: "",
    label: "Date of Birth",
    validation: fieldValidations.legalAge,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantPlaceOfBirth: {
    value: "",
    label: "Place of Birth",
    validation: fieldValidations.hasForbiddenChars,
    errMessage: "",
    placeholder: "City/County, State, and Country",
    className: "",
    isRequired: true,
    maxLength: "100"
  },
  applicantIdType: {
    value: "",
    legend: "ID Type ",
    options: [
      { label: "Driver's License", value: "1" },
      { label: "Military ID", value: "12" },
      { label: "Passport", value: "11" },
      { label: "State-Issued ID", value: "13" }
    ],
    validation: fieldValidations.validateRadio,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantIdNumber: {
    value: "",
    label: "ID Number",
    validation: fieldValidations.hasForbiddenChars,
    errMessage: "",
    maxLength: "30",
    className: "",
    isRequired: true
  },
  applicantSsn: {
    value: "",
    label: "Last 4 digits of SSN",
    tipTitle: "",
    info:
      "Enter “1111” if you do not have a valid SSN (for example, internatonal applicants). Providing a false SSN will automatcally disqualify your applicaton.",
    validation: fieldValidations.isLastFourSsn,
    errMessage: "",
    className: "",
    maxLength: 4,
    isRequired: true
  },
  applicantRace: {
    value: "",
    legend: "Race ",
    options: [
      { label: "American Indian or Alaskan Native", value: "15" },
      { label: "Asian or Pacific Islander", value: "16" },
      { label: "Black", value: "17" },
      { label: "Unknown", value: "19" },
      { label: "White", value: "18" }
    ],
    validation: fieldValidations.validateRadio,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantSex: {
    value: "",
    legend: "Sex ",
    options: [{ label: "Female", value: "13" }, { label: "Male", value: "12" }],
    validation: fieldValidations.validateRadio,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantVisitationType: {
    value: "",
    label: "",
    options: [
      { label: "In-Person", secondLine:"Visitation", value: "in-person visitation only" },
      { label: "AFOI Center", secondLine:"Video Visitation", value: "AFOI Center video visitation only" },
      { label: "Both", secondLine:"(In-Person & Video Visitation)", value: "both in-person and AFOI video visitation" },
    ],
    validation: fieldValidations.validateRadio,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantHair: {
    value: "",
    legend: "Hair Color ",
    options: [
      { label: "Bald", value: "1" },
      { label: "Black", value: "2" },
      { label: "Blonde/Strawberry", value: "3" },
      { label: "Blue", value: "4" },
      { label: "Brown", value: "5" },
      { label: "Gray/Partially Gray", value: "6" },
      { label: "Green", value: "7" },
      { label: "Orange", value: "8" },
      { label: "Pink", value: "9" },
      { label: "Purple", value: "10" },
      { label: "Red", value: "11" },
      { label: "Sandy", value: "12" },
      { label: "White", value: "13" }
    ],
    validation: fieldValidations.validateRadio,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantEyes: {
    value: "",
    legend: "Eye Color ",
    options: [
      { label: "Blue", value: "6" },
      { label: "Brown", value: "2" },
      { label: "Gray", value: "7" },
      { label: "Green", value: "3" },
      { label: "Hazel", value: "8" },
      { label: "Maroon", value: "4" },
      { label: "Multicolored", value: "9" },
      { label: "Pink", value: "5" }
    ],
    validation: fieldValidations.validateRadio,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantHeightFt: {
    value: "",
    label: "Feet",
    validation: fieldValidations.isValidFeet,
    errMessage: "",
    className: "",
    isRequired: true,
    maxVal: "10"
  },
  applicantHeightIn: {
    value: "",
    label: "Inches",
    maxVal: "11",
    validation: fieldValidations.isValidInches,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantWeight: {
    value: "",
    label: "lbs",
    validation: fieldValidations.isNumeric,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantCountry: {
    value: "United States",
    countryName: "",
    label: "Country",
    validation: fieldValidations.isNumeric,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantStreet: {
    value: "",
    label: "Current Street Address",
    validation: fieldValidations.hasForbiddenChars,
    errMessage: "",
    className: "",
    maxLength: "50",
    isRequired: true
  },
  applicantZip: {
    value: "",
    label: "Zip Code",
    validation: fieldValidations.isValidZipcode,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantCity: {
    value: "",
    label: "City",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantState: {
    value: "",
    label: "State",
    numCode: "",
    validation: fieldValidations.nameValidate,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantEmail: {
    value: "",
    label: "Email Address",
    maxLength: "254",
    validation: fieldValidations.isValidEmail,
    errMessage: "",
    className: "",
    isRequired: true
  },
  applicantPhoneType: {
    value: "",
    legend: "Phone Type",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    options: [
      { label: "Home", value: "53" },
      { label: "Cell", value: "51" },
      { label: "Work", value: "50" }
    ],
    isRequired: true
  },
  minorCertification: {
    value: false,
    label:
      "I certify the above information is true for the minor being added to this application. ",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    isRequired: true
  },
  selectedMinors: {},
  finalAuthorization: {
    value: false,
    label:
      "I authorize the Virginia Department of Corrections to conduct a criminal records check or to use any Department of Corrections records to verify accuracy of information provided on this form.",
    validation: fieldValidations.validateRadio,
    errMessage: "",
    isRequired: true
  }
};



// WEBPACK FOOTER //
// ./src/utils/formFields.js